<template>
<div>
  <div>
    <el-table
      :data="page.list"
      stripe
      style="width: 100%">
      <el-table-column
        prop="checkin_num"
        label="入住编号"
        width="180">
      </el-table-column>
      <el-table-column
        prop="checkin_name"
        label="入住人姓名"
        width="180">
      </el-table-column>
      <el-table-column
        prop="owner_id"
        label="业主编号">
      </el-table-column>
      <el-table-column
        prop="owner_name"
        label="业主名称">
      </el-table-column>
      <el-table-column
        prop="checkin_time"
        label="入住时间">
      </el-table-column>
      <el-table-column
        prop="out_time"
        label="搬出时间">
      </el-table-column>
      <el-table-column
        prop="admin_name"
        label="操作员">
      </el-table-column>
    </el-table>
  </div>
  <div>
    <el-pagination
      background
      layout="prev, pager, next"
      :page-count="(page.p*1)"
      :page-size="page.size"
      :total="page.total"
      @current-change="getData(id,$event)">
    </el-pagination>
  </div>
</div>
</template>

<script>
export default {
  name: "CustomerCheckinLog",
  data(){
    return{
      page:{
        list:[],
        p:0,
        size:0,
        total:0
      }

    }
  },
  props:{
    id:{
      type:Number,
      default(){
        return 0
      }
    }
  },
  mounted() {

  },
  methods:{
    getData(id,p){
      var that=this;
      ERP.getRequest({url:"admin/CustomerManagement/getCheckinLog",data:{id:id,p:p}},ret=>{
        if(ret.code){
          console.log(ret.data)
          that.page=ret.data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    setData(){
      var that=this;
      // ERP.postRequest({url:"admin/CustomerManagement/setCheckin",data:that.form},ret=>{
      //   if(ret.code){
      //     this.$msgbox.alert(ret.msg||"修改成功")
      //   }else{
      //     this.$msgbox.alert(ret.msg||"修改失败")
      //   }
      // })
    }
  },
  watch:{
    id(n,o){
      if(n){
        this.getData(n,1);
      }
    }
  }

}
</script>

<style lang="scss" scoped>
@import url(common.scss);
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/CustomerCheckinLog.vue